<template>
  <div class="wrapper" style="background: #232829">

    <!--第一部分搜索框  disable为false-->
    <div class="search">
      <cube-input ref="search" @keypress.native="searchPress" :clearable='true' class="input" v-model="value" :placeholder="placeholder" :maxlength="maxlength" ></cube-input>
      <div class="iconfont icon-sousuo" v-on:click="getDoctorInfoListData"></div>
      <div class="div-select">
        <cube-button class="city" style="width: 40%" @click="showCity"><span class="span-dep-address">{{cityName}}</span></cube-button>
        <cube-button class="city" style="width: 40%" @click="showDepartment"><span class="span-dep-address">{{depValue}}</span></cube-button>
      </div>
    </div>

    <br>
    <br>

    <!--第三部分医生列表-->
    <div class="list-wrapper">
      <cube-scroll
        ref="scroll"
        :data = 'doclist'
        :options="option"
        @pulling-up="onPullingUp">
        <div  class="item-view" v-for="(item) in doclist" :key="item.id">
      <!--医生照片-->
          <div class="item-heard-img">
            <img style="width: 100%;height: 100%; border-radius: 8px;" v-lazy="item.headPortrait">
          </div>
          <!--医生信息-->
          <div class="item-text">
            <div class="new-item-title1">
              <div class="item-info1">{{item.realname}}</div>
              <div class="item-info1">{{item.jobtitle}}</div>
            </div>
            <div class="item-info3">{{item.hospitalName}}</div>
            <div class="item-info4">{{item.departChild}}</div>

            <div class="button" v-on:click="toDocDetail(item.id)">预约</div>
          </div>
        </div>
    </cube-scroll>

    </div>

    </div>

  </div>
</template>

<script>
import { getHospitalRegion, getDepartments, getDoctorInfoList } from '@/api/docApi'

const cityColumn = []

const departmentColumn = []

export default {
  components: {
  },
  props: {},
  data () {
    return {
      value: '',
      page: 1,
      address: '',
      depId: '',
      cityName: '全部城市',
      depValue: '全部科室',
      placeholder: '搜索医生姓名／疾病名称／科室细分',
      type: 'String',
      maxlength: 100,
      doclist: [],
      citys: [],
      department: []
    }
  },
  watch: {},
  computed: {
    option () {
      return {
        pullUpLoad: {
          visible: true,
          threshold: 500
        },
        scrollbar: false
      }
    }
  },
  methods: {
    searchPress (event) {
      if (event.keyCode === 13) { // 如果按的是enter键 13是enter
        event.preventDefault() // 禁止默认事件（默认是换行）
        this.$refs.search.blur()
        this.getDoctorInfoListData()
      }
    },

    // 预约按钮获取docID
    toDocDetail (docId) {
      this.$router.push({
        path: '/docDetail',
        query: {
          docId: docId
        }
      })
    },

    // 科室下拉列表
    showDepartment () {
      if (!this.departmentPicker) {
        this.departmentPicker = this.$createPicker({
          title: '科室',
          data: [departmentColumn],
          onSelect: this.selectDepartment,
          onCancel: this.cancelHandle
        })
      }
      this.departmentPicker.show()
    },
    // 确定(科室)
    selectDepartment (selectedVal, selectedIndex, selectedText) {

      if (selectedIndex[0] === 0) {
        this.depId = ''
        this.depValue = selectedText[0]
        this.getDoctorInfoListData()
      }

      this.depId = selectedVal[0]
      this.depValue = selectedText[0]
      this.getDoctorInfoListData()
    },

    // 城市下拉列表
    showCity () {
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: '城市',
          data: [cityColumn],
          onSelect: this.selectCity,
          onCancel: this.cancelHandle
        })
      }
      this.picker.show()
    },
    // 确定 (城市)
    selectCity (selectedVal, selectedIndex, selectedText) {

      if (selectedIndex[0] === 0) {
        this.address = ''
        this.cityName = selectedText[0]
        this.getDoctorInfoListData()
      } else {
        this.address = selectedVal[0]
        this.cityName = selectedText[0]
        this.getDoctorInfoListData()
      }
    },
    // 取消
    cancelHandle () {
      this.$createToast({
        type: 'correct',
        txt: '已取消',
        time: 1000
      }).show()
    },
    prepare () {
      this.getData()
      this.getDepartData()
      this.getDoctorInfoListData()
      // this.doclist = res3.obj
      // console.log(3)
    },
    /**
     * 获取地区
    */
    async getData () {
      const res = await getHospitalRegion()
      const result = res.obj
      this.citys = result

      const allCity = { text: '所有城市', value: '0' }
      cityColumn.push(allCity)
      /* this.citys.push(allCity)
      console.log(this.citys) */


      for (let index = 0; index < this.citys.length; index++) {
        const text = this.citys[index]?.key
        const value = this.citys[index]?.value
        const city = {}
        city.text = text
        city.value = value
        cityColumn.push(city)
      }

      return cityColumn
    },
    /**
     * 获取科室
    */
    async getDepartData () {
      const res = await getDepartments()
      const result = res.obj
      this.department = result

      const allDep = { text: '所有科室', value: '所有科室' }
      departmentColumn.push(allDep)
      
      for (let index = 0; index < this.department.length; index++) {
        const text = this.department[index]?.name
        const value = this.department[index]?.id
        const department = {}
        department.text = text
        department.value = value
        departmentColumn.push(department)
      }
      return departmentColumn
    },
    async getDoctorInfoListData () {
      this.page = 1
      const params = {
        parm: this.value,
        address: this.address,
        depId: this.depId,
        page: 1,
        size: '20'
      }
      try {
        const res = await getDoctorInfoList(params)
        this.doclist = res.obj
      } catch (error) {
        this.$refs.scroll.forceUpdate()
      }
      // const res = await getDoctorInfoList(params)
      // console.log(res)

      // this.doclist = res.obj
      // console.log(res.obj)

      // return res
    },
    async loadMore () {
      const p = this.page + 1
      const params = {
        parm: this.value,
        address: this.address,
        depId: this.depId,
        page: p,
        size: '20'
      }
      try {
        const res = await getDoctorInfoList(params)
        if (res.obj && res.obj.length > 0) {
          this.page = this.page + 1
          this.doclist = this.doclist.concat(res.obj)
        } else {
          this.$refs.scroll.forceUpdate()
          this.toast = this.$createToast({
            time: 1000,
            txt: '暂无更多',
            type: 'txt'
          }).show()
        }
      } catch (err) {
        this.$refs.scroll.forceUpdate()
      }
    },
    onPullingUp () {
      // 如果没有新数据
      this.loadMore()
    }
  },
  created () {
    this.prepare()
  },
  mounted () {}
}
</script>
<style lang="stylus" scoped>

.span-dep-address{
  position fixed;
}

.wrapper {
  position fixed
  left 0
  top 0
  width 100%
  height 100%
}
.list-wrapper {
  position absolute
  top 130px
  width 100%
  bottom 0
  overflow hidden
  background-color #232829
}
  .input{
    background: rgb(41, 43, 45);
    flex: 1;
    border:1.5px solid #FFF229;
    border-radius 30px
    overflow hidden
    padding-left 10px
  }
  >>>.cube-input::after {
    border: none
  }
  >>>.cube-input-field{
    color: white !important
  }

  .search-input{
    padding: 0;
    height: 100%;
    font-size: 13px;
    background: rgb(41, 43, 45);
    border: 0px;
    flex: 1;
    color: white;
    border: 0.5px solid #FFF229;
    margin-right: 5px;
    height: 75%;
    flex:1;
  }

  .search{
    padding 10px
    display :flex
    border-bottom: solid 1PX rgba(255,255,255,0.5);
  }
  .view-top1{
    display: flex;
    display: -webkit-flex;
    padding: 0;
    position: fixed;
    flex-wrap: nowrap;
    justify-content: space-around;
    align-items: center;
    -webkit-flex-wrap: nowrap;
    -webkit-justify-content: space-around;
    -webkit-align-items: center;
    top: 15px;
    width: 100%;
    height: 49px;
    background: rgb(41, 43, 45);
    z-index: 100;
  }

  .div-select{
    display: flex;
    display: -webkit-flex;
    padding: 0;
    position: fixed;
    justify-content: space-around;
    align-items: center;
    -webkit-justify-content: space-around;
    -webkit-align-items: center;
    top: 64px;
    width: 100%;
    height: 50px;
    z-index: 100;
    margin-top:7px;
  }

  .city {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    -webkit-justify-content: center;
    -webkit-align-items: center;
    height: 80%;
    text-decoration: none;
    text-align: center;
    -webkit-text-decoration: none;
    -webkit-text-align: center;
    border-radius: 1.25rem;
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: none;
    color: white;
    background-color: #232829;
    border: 1px solid #FFF229;
  }

  .item-heard-img {
    flex-shrink: 0;
    width: 70px;
    height: 70px;
    margin-left: 15px;

  }

  .item-view {
    /*border-bottom: 1px solid rgb(62, 64, 66);*/
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: nowrap;
    display: -webkit-flex;
    -webkit-align-items: center;
    -webkit-justify-content: flex-start;
    -webkit-flex-direction: row;
    -webkit-flex-wrap: nowrap;
    // margin-top :5px;
    position: relative;
    border-bottom rgba(255,255,255,0.1) solid 1PX;
    background-color #272c2d
  }

  .item-heard-img {
    flex-shrink: 0;
    width: 70px;
    height: 70px;
    margin-left: 15px;

  }
  [lazy=loaded] {
      background: transparent;
      animation: fade 0.5s;
    }
    @keyframes fade {
      0% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }

  .item-text {
    height: 70%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    display: -webkit-flex;
    -webkit-flex-direction: column;
    -webkit-justify-content: space-around;
  }

  .new-item-title1{
    display: flex;
    flex-direction: row;
    align-items: baseline;
    display: -webkit-flex;
    -webkit-flex-direction: row;
    -webkit-align-items: baseline;
    //margin-top: 1px;
  }

  .item-info1{
    padding: 0;
    font-size: 15px;
    margin-left: 20px;
    color: #eee;

  }

  .item-info3{
    padding: 0;
    font-size: 13px;
    margin-left: 20px;
    color: #ebebeb;
    word-wrap:break-word;
    width: 150px;
  }

  .item-info4{
    padding: 0;
    font-size: 15px;
    margin-left: 20px;
    color: #ebebeb;
}

  .button {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    -webkit-justify-content: center;
    -webkit-align-items: center;
    width: 77px;
    height: 32px;
    color: #151518;
    text-decoration: none;
    text-align: center;
    -webkit-text-decoration: none;
    -webkit-text-align: center;
    border-radius: 1.25rem;
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: none;
    background: #FFF229;
    font-size: 16px;
    position absolute
    right 0;
    top: 35px;
    margin-right: 10px;
  }

</style>
